import { canAccess } from '../../../utils/permission';

export default function Permit(props) {
    return (canAccess(props) ? props.children : null);
}



// WEBPACK FOOTER //
// ./src/components/common/permit/Permit.jsx